import React from 'react';
import FilterTab from '../../molecules/filter_tab/filter_tab.js';
import Button from '../../molecules/button/button.js';
import Avatar from '../../molecules/avatar/avatar.js';
import Title from '../../atoms/title/title.js';
import { Clock } from './assets/Clock.js';
import { Stars } from './assets/Stars.js';
import { ChatTypeIcon } from './assets/ChatTypeIcon.js';

const MyOrdersDetailsItem = ({ avatarSrc, time, date, type, tabText, tabIcon, title, subTitle, buttonLinkText, buttonLinkIcon, buttonLinkCallBack }) => {
    return (React.createElement("div", { "data-test-id": `${type}`, className: "mbw-my-orders-details-item" },
        React.createElement("div", { className: "mbw-my-orders-details-top-block" },
            React.createElement("div", { className: "mbw-my-orders-details-flex" },
                React.createElement("div", { className: "mbw-my-orders-details-avatar-block" },
                    React.createElement(Avatar, { imgSrc: avatarSrc, size: "large" }),
                    React.createElement(Avatar, { imgSrc: avatarSrc, size: "large" }),
                    React.createElement("div", { className: `mbw-my-orders-details-avatar-middle-icon-${type}` },
                        React.createElement(ChatTypeIcon, null))),
                React.createElement("div", null,
                    React.createElement("div", { className: "mbw-my-orders-details-flex" },
                        React.createElement(Clock, null),
                        React.createElement(Title, { fontStyle: "heading-h3", bold: true }, time),
                        React.createElement("br", null)),
                    React.createElement(Title, { fontStyle: "content-default" }, date))),
            React.createElement(FilterTab, { title: tabText, icon: tabIcon })),
        React.createElement("div", { className: "mbw-my-orders-details-bottom-block" },
            React.createElement("div", { className: "mbw-my-orders-details-flex" },
                React.createElement(Stars, null),
                React.createElement("div", null,
                    React.createElement(Title, { fontStyle: "heading-h6", bold: true }, title),
                    React.createElement("br", null),
                    React.createElement(Title, { fontStyle: "content-medium" }, subTitle))),
            React.createElement("div", null,
                React.createElement(Button, { type: "link", onClick: () => buttonLinkCallBack, title: buttonLinkText, icon: buttonLinkIcon })))));
};

export { MyOrdersDetailsItem as default };
//# sourceMappingURL=my_orders_details_item.js.map
